import { render, staticRenderFns } from "./AdSetsList.vue?vue&type=template&id=06154845&scoped=true"
import script from "./AdSetsList.vue?vue&type=script&lang=js"
export * from "./AdSetsList.vue?vue&type=script&lang=js"
import style0 from "./AdSetsList.vue?vue&type=style&index=0&id=06154845&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06154845",
  null
  
)

export default component.exports